import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { Row } from '@/main/utils/table';
import { DropdownItem } from '@/main/store/@types/dropdown.d';

import { types } from './types';

import { NAME as name, CRUMB_LABEL_KEY, COLUMN_SHARE_PERCENTAGE, COLUMN_DISCOUNT_PERCENT, COLUMN_DISCOUNT_AMOUNT, DEFAULT_ID } from '../constants';
import { apiProvider } from '../api';
import { ISplitPartyInvoiceDetail } from './SplitBillingDetails';


export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		InvoiceChargeTypes: [] as DropdownItem[],
		InvoiceDepartments: [] as DropdownItem[],
	},
	filter: {
		ServiceOrderId: null as number | null,
		ItemId: null as number | null,
		ItemType: null as string | null,
		OrderStatus: null as number | null,
		Modified: null as number | null,
		Saga2Prp: null as boolean| null,
		IsOrderSentToSaga: null as boolean | null,
	},
	tableSetting: {
		isEditable: true,
		columnSettings: {
			[COLUMN_SHARE_PERCENTAGE]: { isEditable: true },
			[COLUMN_DISCOUNT_PERCENT]: { isEditable: true },
			[COLUMN_DISCOUNT_AMOUNT]: { isEditable: true },
		},
		computeHashOnLoad: true,
	},
	localState: {
		ZakaznikId: null as number | null,
		ZakaznikIdText: null as string | null,
		InvoiceChargeTypeId: DEFAULT_ID as number | null,
		InvoiceDepartmentId: DEFAULT_ID as number | null,
		defaultRowModel: { cells: {} },
		rowIndex: null as number | null,
		row: {} as Row,
		uniqueRowIndex: 0 as number | null,
		splitPartyInvoiceDetails: [] as ISplitPartyInvoiceDetail[] | null,
		pageLoaded: false as boolean,
		deepCopiedTableRows: [] as Row[],
		allRowsBilled: false as boolean,
	},
	rowDetail: null,
	extraActions: {},
	extraGetters: {
	},
	extraMutations: {
		[types.mutations.SPLIT_CUSTOMER_LIST_MAPPER](state, { data }) {
			state.localState.ZakaznikId = data.value;
			state.localState.ZakaznikIdText = data.text;
		},
	},
	props: {
		mode: null,
		filter: {
			ServiceOrderId: null as Number | null,
			ItemId: null as Number | null,
			OrderStatus : null as number | null,
			IsOrderSentToSaga: null as boolean | null,
		},
		afterRowSelection: () => {},
	},
});
